import { useTranslation } from 'react-i18next';

import { useRouteLoaderData } from '@remix-run/react';

import type { RootLoaderData } from '~/root';
import type { loader as communityLoader } from '~/routes/community';

export const useCommunityDisplayName = (): string => {
  const { t } = useTranslation();
  const layoutData = useRouteLoaderData<typeof communityLoader>('routes/community');
  const rootData = useRouteLoaderData<RootLoaderData>('root');

  return layoutData?.community?.name || rootData?.site?.publication?.name || t('community.community_name_fallback');
};
